import React from "react";

const StoricoPuntiModal = ({ storicoPunti, onClose }) => {
  return (
    <div className="modal d-block" onClick={onClose}>
      <div className="modal-dialog modal-dialog-scrollable" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5>📜 Storico Punti</h5>
            <button className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            {storicoPunti.length === 0 ? (
              <p>Nessun movimento.</p>
            ) : (
              <ul className="list-group">
                {storicoPunti.map((log, i) => (
                  <li key={i} className="list-group-item">
                    <strong>{parseFloat(log.points)?.toFixed(2)} pts</strong> — {log.reason}
                    <br />
                    <small>{new Date(log.created_at).toLocaleString()}</small>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoricoPuntiModal;
